import { assertValue, log } from '@libs/utils';

import type { Coordinate } from './coordinate';

export interface Rectangle {
  topLeft: Coordinate;
  bottomRight: Coordinate;
}

export interface RectangleAndZoom {
  rectangle: Rectangle;
  zoom?: number;
}

export function createPolygonFromRectangle(rectangle: Rectangle): Coordinate[] {
  return [
    rectangle.topLeft,
    {
      latitude: rectangle.topLeft.latitude,
      longitude: rectangle.bottomRight.longitude,
    },
    rectangle.bottomRight,
    {
      latitude: rectangle.bottomRight.latitude,
      longitude: rectangle.topLeft.longitude,
    },
    rectangle.topLeft,
  ];
}

export function isRectangle(coordinates: Coordinate[]): boolean {
  const rectangleCoordinatesTotal = 5;
  if (coordinates.length !== rectangleCoordinatesTotal) {
    return false;
  }

  const topLeft = coordinates[0];
  const topRight = coordinates[1];
  const bottomRight = coordinates[2];
  const bottomLeft = coordinates[3];
  const closingTopLeft = coordinates[4];

  assertValue(topLeft, 'rectangle.ts > isRectangle > topLeft');
  assertValue(topRight, 'rectangle.ts > isRectangle > topRight');
  assertValue(bottomRight, 'rectangle.ts > isRectangle > bottomRight');
  assertValue(bottomLeft, 'rectangle.ts > isRectangle > bottomLeft');
  assertValue(closingTopLeft, 'rectangle.ts > isRectangle > closingTopLeft');

  const shouldBeEqual: Array<[number, number]> = [
    [topLeft.latitude, closingTopLeft.latitude],
    [topLeft.longitude, closingTopLeft.longitude],
    [topLeft.latitude, topRight.latitude],
    [topLeft.longitude, bottomLeft.longitude],
    [topRight.longitude, bottomRight.longitude],
    [bottomLeft.latitude, bottomRight.latitude],
  ];

  log('Coordinates', shouldBeEqual);
  return shouldBeEqual.every((x) => x[0] === x[1]);
}

export function tryCreateRectangle(
  coordinates: Coordinate[]
): Rectangle | null {
  if (!isRectangle(coordinates)) {
    return null;
  }

  return createRectangle(coordinates);
}

export function createRectangle(coordinates: Coordinate[]): Rectangle {
  assertValue(coordinates[0], 'rectangle.ts > isRectangle > coordinates[0]');
  assertValue(coordinates[2], 'rectangle.ts > isRectangle > coordinates[2]');

  return {
    topLeft: coordinates[0],
    bottomRight: coordinates[2],
  };
}
